module.exports = __webpack_public_path__ + "img/selfportrait_in_front_of_Brienzeresee.92a8497f.jpg";